import { offscreenAbstractSite } from "./index230.js";
import { memo, useEffect } from "react";
import { jsx } from "react/jsx-runtime";
import { clear, suspend } from "suspend-react";
const AbstractSiteImg = memo(function AbstractSiteWorkerImg({ obj: site, width, height, orthographic, camDir, style, className, log, plots }) {
	const base64 = suspend(() => offscreenAbstractSite.getBase64Img({
		obj: site,
		width,
		height,
		orthographic,
		camDir,
		plots
	}, log), [
		site,
		width,
		height,
		orthographic,
		camDir,
		log,
		plots
	]);
	useEffect(() => {
		return () => {
			clear([
				site,
				width,
				height,
				orthographic,
				camDir,
				log,
				plots
			]);
		};
	}, [
		site,
		width,
		height,
		orthographic,
		camDir,
		log,
		plots
	]);
	return /* @__PURE__ */ jsx("img", {
		src: base64,
		alt: "site",
		style,
		className
	});
});
export { AbstractSiteImg };

//# sourceMappingURL=index231.js.map